import React from 'react';
import TopicItem from './TopicItem';

// Wrap the component with React.memo to prevent unnecessary re-renders
const TopicList = React.memo(({ topics, selectedTopics, onTopicToggle, searchTerm, highlightText }) => {
  return (
    <div className="flex-grow overflow-y-auto px-2 py-2">
      {topics.map(topic => (
        <TopicItem 
          key={topic.id} 
          topic={topic}
          isSelected={selectedTopics.includes(topic.id)}
          onToggle={() => onTopicToggle(topic.id)} 
          searchTerm={searchTerm}
          highlightText={highlightText}
        />
      ))}
    </div>
  );
});

export default TopicList;
